import * as Yup from 'yup';
import { StepTypeForm } from './step-type-types';

export const stepTypeSchema = () =>
  Yup.object<StepTypeForm>().shape({
    type: Yup.mixed().nullable().required('Povinné pole'),
  });
